<div class="d-flex flex-column justify-content-center align-items-center px-5">

    <!-- Mail -->
    <div class="d-flex flex-column justify-content-center align-items-start w-100 mb-2">
        <span class="text-primary-color fw-bolder">Correo electrónico</span>
        <input type="text" pInputText class="w-100" [(ngModel)]="email" (ngModelChange)="onEmailChange()"/>
        <small *ngIf="!isValidEmail" class="text-danger-color" >{{emailValidationError}}</small>
    </div>

    <!-- Password -->
    <div class="d-flex flex-column justify-content-center align-items-start w-100 mb-2">
        <span class="text-primary-color fw-bolder">Contraseña</span>
        <input type="password" pInputText class="w-100" [(ngModel)]="password"/>
    </div>

    <!-- Error alert -->
    <div *ngIf="errorMessage" class="alert alert-danger w-100 m-0" role="alert">
        {{ errorMessage }}
    </div>

	<!-- Login button -->
    <div class="d-flex flex-column justify-content-center align-items-start w-100 mt-4">

        <button type="button" class="btn button-accent-color w-100 py-2"
            [disabled]="!isFormValid() || isProcessing"
            (click)="login()">

            <div *ngIf="!isProcessing" class="w-100">
                <span class="fs-6">Acceder</span>
            </div>

            <div *ngIf="isProcessing" class="d-flex flex-row justify-content-center align-items-center w-100">
                <fa-icon [icon]="['fas', 'spinner']" [spin]="true"></fa-icon>
            </div>

        </button>

    </div>

</div>

<div class="d-flex flex-column justify-content-center align-items-center my-3">

    <a class="button-link-primary-color fs-5 my-2" [routerLink]="registerUrl" routerLinkActive="active">
        {{registerLabel}}
    </a>

    <a class="button-link-primary-color fs-5 my-2" [routerLink]="forgotUrl" routerLinkActive="active">
        {{forgotLabel}}
    </a>

</div>
